export const CREATE_DMX_PROFILE = 'CREATE_DMX_PROFILE';
export const CREATE_DMX_PROFILE_SUCCESSFUL = 'CREATE_DMX_PROFILE_SUCCESSFUL';
export const CREATE_DMX_PROFILE_FAILED = 'CREATE_DMX_PROFILE_FAILED';
